<script>
  import { onMount } from "svelte";
  import {
    actionTypes,
    addHash,
    localeOrderBy,
    slice,
    loadPersisted,
    savePersisted,
  } from "../../mjnUtils";
  import { balance } from "../../finances";
  import Pagination from "./pagination/Pagination.svelte";

  let { http, toastr, search, openModal } = $props();

  const fields = addHash(
    [
      { name: "wszystkie", field: "$" },
      { name: "saldo", field: "saldo" },
    ],
    "name",
  );

  let data = $state([]);
  let searchText = $state("");
  let searchFieldName = $state(loadPersisted("contributions", "searchFieldName", "wszystkie"));
  let sortType = $state(loadPersisted("contributions", "sortType", "nazwisko"));
  let sortReverse = $state(loadPersisted("contributions", "sortReverse", true));
  let currentPage = $state(1);
  const itemsPerPage = 11;

  const today = new Date();
  let yearAsSet = $state(loadPersisted("contributions", "yearAsSet", today.getFullYear()));
  let monthAsSet = $state(loadPersisted("contributions", "monthAsSet", today.getMonth() + 1));
  let year = $state(null);
  let month = $state(null);
  let contribution = $state(0);
  let finances = $state(null);

  let menuOpen = $state(false);
  let searchMenuOpen = $state(false);

  $effect(() => {
    savePersisted("contributions", "searchFieldName", searchFieldName);
    savePersisted("contributions", "sortType", sortType);
    savePersisted("contributions", "sortReverse", sortReverse);
    savePersisted("contributions", "yearAsSet", yearAsSet);
    savePersisted("contributions", "monthAsSet", monthAsSet);
  });

  let searchField = $derived(fields.hash[searchFieldName] || fields[0]);

  onMount(() => {
    loadContrData();
  });

  function yearRange() {
    const range = [];
    const start = 2019;
    const end = new Date().getFullYear();
    for (let y = start; y <= end; y++) range.push(y);
    return range;
  }

  function balanceFor(member, financesData, y, m) {
    const memberFinances = financesData["members"][member.idcz];
    const [calculatedBalance, yearStartBalance] = balance(y, m, memberFinances);
    member.saldo = calculatedBalance;
    member.saldo_pocz = yearStartBalance;
  }

  function loadContrData() {
    year = yearAsSet;
    month = monthAsSet;
    Promise.all([
      http.get("/api/skladki.php?year=" + year),
      http.get("/api/wys_skladek.php?year=" + year),
      http.get("/api/akcja.php"),
      http.get("/api/finances.php"),
    ]).then(
      (response) => {
        if (response[3].data.status !== 200) {
          console.log(
            `Unable to get finances data! status: ${response[3].status_code} content: ${response[3].data}`,
          );
        }
        if (response[0].data.status == 200 && response[1].data.status == 200) {
          const loadedData = addHash(response[0].data.records, "idcz");
          finances = response[3].data.payload;
          for (const item of loadedData) {
            item.actions = [];
            item.actions_text = "";
          }
          contribution = response[1].data.records[0].kwota;
          const actions = response[2].data.records;
          for (const action of actions) {
            const tDate = new Date(action.data_od);
            action.year = tDate.getFullYear();
            action.month = tDate.getMonth() + 1;
            action.day = tDate.getDate();
            if (action.data_do !== null) {
              const tDateTo = new Date(action.data_do);
              action.yearTo = tDateTo.getFullYear();
              action.monthTo = tDateTo.getMonth() + 1;
              action.dayTo = tDateTo.getDate();
            }
            if (loadedData.hash[action.idcz] !== undefined) {
              loadedData.hash[action.idcz].actions.push(action);
              loadedData.hash[action.idcz].actions_text +=
                actionTypes.hash[action.typ].abbr;
            }
          }
          for (const item of loadedData) {
            balanceFor(item, finances, year, month);
          }
          data = loadedData;
          currentPage = 1;
        } else {
          toastr.error("Błąd: " + response[0].data.message);
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  }

  function refresh() {
    if (year != yearAsSet) {
      loadContrData();
    } else {
      year = yearAsSet;
      month = monthAsSet;
      for (const item of data) {
        balanceFor(item, finances, year, month);
      }
    }
  }

  function setSearchField(option) {
    searchFieldName = option.name;
  }

  function exportCsv() {
    const output = Papa.unparse(data, {
      columns: ["imie", "nazwisko", "email", "saldo", "nrtel"],
    });
    const blob = new Blob([output], { type: "text/plain;charset=utf-8" });
    saveAs(blob, "skladki.csv");
  }

  function transferBalances() {
    const transferYear = year + 1;
    if (
      confirm(
        "Wykonanie tego polecenia ustawi obliczone na tej stronie salda końcowe jako początkowe w roku " +
          transferYear +
          ". Czy to jest to co chcesz zrobić?",
      )
    ) {
      const balances = data.map((item) => ({
        idcz: item.idcz,
        rok: transferYear,
        kwota: item.saldo,
      }));
      http.post("/api/ustaw-salda.php?method=bulk", balances).then(
        (response) => {
          if (response.data.status == 200) {
            toastr.info("Uaktualniono " + balances.length + " sald");
          } else {
            toastr.error("Błąd: " + response.data.message);
          }
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
    }
  }

  function prepareSend() {
    menuOpen = false;
    openModal("MailSendModal", { filteredData }).catch(() => {});
  }

  let searchObject = $derived({ [searchField.field]: searchText });
  let filteredData = $derived(search(data, searchObject, fields.hash));
  let sortedData = $derived(localeOrderBy(filteredData, sortType, sortReverse));
  let totalItems = $derived(filteredData.length);
  let numPages = $derived(Math.max(1, Math.ceil(totalItems / itemsPerPage)));
  let pagedData = $derived(slice(sortedData, itemsPerPage, currentPage));

  let sumOfBalances = $derived(filteredData.reduce((sum, item) => sum + item.saldo, 0));
  let sumOfBalances2 = $derived(
    filteredData.reduce((sum, item) => sum + (item.saldo < 0 ? item.saldo : 0), 0),
  );
  let numOfDebtors = $derived(filteredData.filter((item) => item.saldo < 0).length);

  $effect(() => {
    searchText;
    searchFieldName;
    currentPage = 1;
  });

  function setSort(field) {
    if (sortType === field) {
      sortReverse = !sortReverse;
    } else {
      sortType = field;
      sortReverse = false;
    }
  }

  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
</script>

<svelte:window onclick={() => { menuOpen = false; searchMenuOpen = false; }} />

<h3><i class="fas fa-piggy-bank fa-lg"></i>&nbsp;&nbsp;Składki
<div class="btn-toolbar pull-right form-inline">
    <div class="btn-group pull-right" class:open={menuOpen}>
        <button type="button" class="btn btn-primary btn-sm dropdown-toggle" aria-haspopup="true" onclick={(e) => { e.stopPropagation(); menuOpen = !menuOpen; }}><i class="fas fa-bars" aria-hidden="true"></i>
        <span class="hidden-xs">&nbsp;Inne polecenia&nbsp;&nbsp;</span><span class="caret"></span></button>
        <ul class="dropdown-menu dropdown-menu-right" role="menu">
            <li role="menuitem" onclick={prepareSend} title="Otwiera okienko, w którym można wysłać pocztę do wszystkich Członków z listy poniżej informując ich o zaległościach składkowych.">
                <a href="#" onclick={(e) => e.preventDefault()}><i class="far fa-envelope" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Wyślij pocztę...</a>
            </li>
            <li role="menuitem" onclick={() => { menuOpen = false; transferBalances(); }} title="Umożliwia przeniesienie sald na następny rok. Na poczatku nowego roku oblicz salda na koniec roku poprzedniego (tzn. przelicz salda na koniec grudnia) i użyj tej opcji, żeby zostały one użyte jako salda otwierające następny rok.">
                <a href="#" onclick={(e) => e.preventDefault()}><i class="far fa-hand-point-right" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Przenieś salda na {(year || 0)+1}...</a>
            </li>
        </ul>
    </div>
    <button class="btn btn-primary btn-sm pull-right" onclick={exportCsv} title="Eksport danych do pliku tekstowego, który można otworzyć w Excelu. Eksportowane są tylko wpisy widoczne na liście poniżej (można je wybrać za pomocą pola wyszukiwania)."><i class="fas fa-share-square" aria-hidden="true"></i>
    <span class="hidden-xs">&nbsp;Eksportuj do csv</span></button>
    <button class="btn btn-primary btn-sm pull-right" onclick={refresh} disabled={yearAsSet==year && monthAsSet==month} title="Oblicza składki poniżej dla wybranego miesiąca i roku obok. Po zmianie miesiąca albo roku trzeba nacisnąć ten przycisk aby zaktualizować zaległości składkowe."><i class="fas fa-calculator" aria-hidden="true"></i>
    <span class="hidden-xs">&nbsp;Oblicz od nowa</span></button>
    <select class="form-control input-sm pull-right" name="year" bind:value={yearAsSet}>
      {#each yearRange() as y}<option value={y}>{y}</option>{/each}
    </select>
    <select class="form-control input-sm pull-right" name="month" bind:value={monthAsSet}>
      {#each months as m}<option value={m}>{m}</option>{/each}
    </select>
</div>
</h3>
<div class="clearfix"></div>
<div class="text-left"><small>
<i class="fas fa-random" aria-hidden="true"></i>
Obliczono składki dla {data.length} członków{#if searchText != ""}, przefiltrowanych poniżej {filteredData.length}{/if}. Wysokość składki w roku {year} to {contribution} zł. Suma zaległości i nadpłat {#if searchText != ""}dla przefiltrowanych {/if}wynosi {sumOfBalances.toFixed(2)} zł (zalega {numOfDebtors} członków na sumę {sumOfBalances2.toFixed(2)})
</small><p></p></div>

<form>
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-addon"><i class="fa fa-search"></i></div>
        <input type="text" class="form-control input-sm" placeholder="Wyszukaj osobę" bind:value={searchText}>
        <div class="input-group-btn" class:open={searchMenuOpen}>
          <button type="button" class="btn btn-default btn-sm dropdown-toggle" aria-haspopup="true" onclick={(e) => { e.stopPropagation(); searchMenuOpen = !searchMenuOpen; }}><span class="hidden-xs">Przeszukaj: </span>{searchField.name}&nbsp;&nbsp;<span class="caret"></span></button>
          <ul class="dropdown-menu dropdown-menu-right" role="menu">
            {#each fields as option}<li role="menuitem" onclick={() => { setSearchField(option); searchMenuOpen = false; }}><a href="#" onclick={(e) => e.preventDefault()}>{option.name}</a></li>{/each}
          </ul>
        </div>
      </div>
    </div>
</form>

<table class="table table-condensed table-hover table-striped">

    <thead class="thead-default">
      <tr>
      	<th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("nazwisko"); }}>
          Dotyczy osoby
          {#if sortType == "nazwisko" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "nazwisko" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("data_uchwaly"); }}>
          W MJN od
          {#if sortType == "data_uchwaly" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "data_uchwaly" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("nastepny_kontakt"); }}>
          Następny kontakt
          {#if sortType == "nastepny_kontakt" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "nastepny_kontakt" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs hidden-sm">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("saldo_pocz"); }}>
          Saldo początkowe
          {#if sortType == "saldo_pocz" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "saldo_pocz" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        {#each months as m}
        <th class="hidden-xs hidden-sm">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("w" + m); }}>
          {m}
          {#if sortType == "w"+m && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "w"+m && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        {/each}
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("actions_text"); }}>
          Umorzenia
          {#if sortType == "actions_text" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "actions_text" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("saldo"); }}>
          Saldo końcowe
          {#if sortType == "saldo" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "saldo" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
      </tr>
    </thead>

    <tbody>
      {#each pagedData as item (item.idcz)}
      <tr>
        <td>
            <i class="fas fa-{item.saldo<0 ? 'exclamation-circle' : 'check-square'} fa-lg fa-fw" aria-hidden="true" style="margin: 6px 0px 8px 0px;"></i>
            &nbsp;&nbsp;
            <a href={"/member-detail/" + item.idcz}>
                {item.imie} {item.nazwisko}
            </a>
        </td>
        <td>
          {item.data_uchwaly}
        </td>
        <td>
          {item.nastepny_kontakt}
        </td>
        <td class="hidden-xs hidden-sm">
        {item.saldo_pocz !== null ? item.saldo_pocz : "-"}
        </td>
        {#each months as m}
        <td class="hidden-xs hidden-sm">
        {m>month ? "" : item["w"+m]}
        </td>
        {/each}
        <td class="hidden-xs">
        <a href={"/member-detail/" + item.idcz + "?tab=3"}>{item.actions_text}</a>
        </td>
        <td>
        {item.saldo}
        </td>
      </tr>
      {/each}
    </tbody>

</table>

<Pagination {currentPage} {numPages} onPageChange={(page) => currentPage = page}/>
